module.exports = __webpack_public_path__ + "img/travolta.a23420d1.png";